<template>
  <a v-show="geolocationAvailable" :class="{ 'screenReaderOnly': !isVisible }" class="geolocationButton" href="#" @click.prevent="getUserLocation" :alt="altText">
    Or use current location
  </a>
</template>

<script>

export default {
  props: {
    updateLocation: {
      type: Function,
      default: () => {}
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    showLoading: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      altText: 'Find congressional districts near me',
      geolocationAvailable: true
    }
  },
  created() {
    this.geolocationAvailable = navigator.geolocation ? true : false;
  },
  methods: {
    getUserLocation () {
      if (this.geolocationAvailable) {
        this.showLoading ? this.showLoading(true) : null;
        navigator.geolocation.getCurrentPosition(this.updateUserLocation, this.errorUserLocation);
      }
    },
    updateUserLocation (position) {
      let location = L.latLng(position.coords.latitude, position.coords.longitude);
      if (typeof this.updateLocation == 'function') {
        this.updateLocation(location);
      }
    },
    errorUserLocation (error) {
      this.showLoading ? this.showLoading(false) : null;
      console.error(error);

      this.showErrorMessage(error)
    },
    showErrorMessage (error) {
      let message = error.message || '';
      switch(error.code) {
        case error.PERMISSION_DENIED:
          message = "User denied the request for Geolocation."
          this.geolocationAvailable = false;
          break;
        case error.POSITION_UNAVAILABLE:
          message = "Location information is unavailable."
          this.geolocationAvailable = false;
          break;
        case error.TIMEOUT:
          message = "The request to get user location timed out."
          break;
        case error.UNKNOWN_ERROR:
          message = "An unknown error occurred."
          break;
      }
      alert(message)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.geolocationButton {
  display: block;
  @include font-family-standard-bold;
  margin-top: 10px;
  color: $grey-40;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/GeolocationAsText.vue